export default __webpack_public_path__ + "static/logo_nbcu-3f48a9464e35a0780c3fa21f79956a37.svg";